//
//
//
//
//
//
//
//
import { DateMixin } from '@/mixins/DateMixin';
export default {
  name: 'dateSelect',
  mixins: [DateMixin],
  mounted: function mounted() {
    this.$emit("change", this.dateFormatFun(this.dateTime));
  },
  methods: {
    // 日期变化
    onServicenDateChange: function onServicenDateChange(value, dateString) {
      this.dateTime = value;
      this.$emit("change", this.dateFormatFun(this.dateTime));
    }
  }
};